import * as styles from "./PromotionCardImageSide.module.scss";

import cx from "classnames";
import React from "react";
import CurvedBorderVertical from "../../../../components/borders/CurvedBorderVertical";
import ProcessedImage from "../../../../components/common/ProcessedImage/ProcessedImage";
import { Colours } from "../../../../utils/colours";
import Button from "../../../common/Button";
export const PromotionCardImageSide: React.FC<
	DogsTrust.SignPostCardProps & { side: "left" | "right" }
> = ({
	imgSrc,
	title,
	body,
	buttonLabel,
	buttonUrl,
	externalUrl,
	isOnDogListing,
	side,
}) => {
	const VerticalBorder = CurvedBorderVertical;
	return (
		<article
			className={cx({
				[styles.promocardleft]: side === "left",
				[styles.promocardright]: side === "right",
				[styles.doglisting]: isOnDogListing,
			})}
		>
			<div className={styles.promocardtextcontainer}>
				<h2 data-variation="hideFromJumpLinks" className={styles.title}>
					{title}
				</h2>
				<p className={styles.promocardtext}>{body}</p>
				<Button
					variant={"tertiary"}
					size="small"
					url={buttonUrl}
					externalUrl={externalUrl}
				>
					{buttonLabel}
				</Button>
			</div>
			<div className={styles.promocardimagecontainer}>
				<ProcessedImage
					className={styles.promocardimage}
					src={imgSrc}
					alt={title}
					dimensions="400x300"
					width={400}
					height={300}
					loading={"lazy"}
				/>
				<VerticalBorder
					className={cx(styles.imageborder, {
						[`${styles[side]}`]: true,
					})}
					rotation={side === "left" ? 180 : 0}
					fill={Colours.WHITE}
					height={"218"}
				/>
			</div>
		</article>
	);
};

export default PromotionCardImageSide;
